import React, { FC } from 'react';
import styled from 'styled-components';
import { ContainerBase } from './containerBase';

export const Container = styled(ContainerBase)`
    max-width: ${(props) => props.theme.size.container};
`;

export const RightColumnLayoutStyled = styled.div`
    max-width: ${(props) => props.theme.size.container};
    display: grid;
    grid-template-columns: auto 350px;
    grid-gap: 40px;
`;

export const RightColumnLayout: FC<{ header?: React.ReactElement; children?: React.ReactNode }> = ({ header, children }) => {
    return (
        <Container>
            {header}
            <RightColumnLayoutStyled>{children}</RightColumnLayoutStyled>
        </Container>
    );
};
